import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling down 500px
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 p-4 bg-slate-900 border-t border-slate-800 shadow-[0_-10px_40px_rgba(0,0,0,0.5)] z-50 md:hidden animate-in slide-in-from-bottom-full duration-300" data-id="element-202">
      <Button href="https://brunocairo.com/cart/50636149457129:1" isExternal fullWidth size="lg" className="shadow-xl" data-id="element-203">
        ¡Inscribirme ahora!
      </Button>
    </div>;
}